module.exports = "<div class=\"bd-{{color}} m-bottom\"> Lorem ipsum dolor sit amet - bd-{{color}}</div>";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader?interpolate!./src/components/guideline/templates/styling_borders_colors.html
// module id = 100
// module chunks = 0